import Vue from 'vue';
import errorUtility from '../services/errorUtility';

export default Vue.mixin({
    methods: {
        handleError
    }
});

function handleError(error) {
    errorUtility.handleServerError(error);
}
